/* Mark & More Knochen Mark Nudge im Slide Cart — carnivoro.eu
 * v2: neuer Dateiname, um CDN-Cache-Kollision zu umgehen.
 * Klicklose Fassung, Rate live via Smile SDK (Retry bis Login-Handshake fertig).
 */
(function () {
  'use strict';

  var BASE_PER_EUR = 10;          // Fallback: 10 KM je 1 EUR (Basisregel "Place an order")
  var NUDGE_ID = 'km-nudge';
  var state = { ratePerEur: BASE_PER_EUR, rateFromSmile: false, customer: undefined };

  function formatKM(n) {
    return Math.floor(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function isLoggedIn() {
    try { return !!(window.__st && window.__st.cid); } catch (e) { return false; }
  }

  function initSmile() {
    try {
      if (typeof window.loadSmileSdk !== 'function') return;
      window.loadSmileSdk();
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (window.Smile && window.Smile.earningRules) {
          clearInterval(t);
          resolveRate();
        } else if (tries > 20) { clearInterval(t); }
      }, 500);
    } catch (e) { /* Fallback-Rate bleibt */ }
  }

  function resolveRate(attempt) {
    attempt = attempt || 0;
    var S = window.Smile;
    Promise.all([
      S.earningRules.get().catch(function () { return null; }),
      isLoggedIn() && S.customer && S.customer.current ? S.customer.current().catch(function () { return null; }) : Promise.resolve(null),
      isLoggedIn() && S.customerVipStatus && S.customerVipStatus.get ? S.customerVipStatus.get().catch(function () { return null; }) : Promise.resolve(null)
    ]).then(function (res) {
      var rules = res[0], customer = res[1], vip = res[2];
      state.customer = customer;
      if (!rules) return render();
      var tierId = vip && vip.vipTier ? vip.vipTier.id : (vip && vip.vip_tier ? vip.vip_tier.id : null);
      var orderRules = rules.filter(function (r) {
        return r.rewardValue && r.rewardValue.type === 'variable';
      });
      var rule = orderRules.filter(function (r) {
        return tierId && r.restrictedToVipTierIds && r.restrictedToVipTierIds.indexOf(tierId) !== -1;
      })[0] || orderRules.filter(function (r) {
        return !r.restrictedToVipTierIds || r.restrictedToVipTierIds.length === 0;
      })[0];
      if (rule) {
        state.ratePerEur = rule.rewardValue.variable.value / (rule.rewardValue.variable.perAmount || 1);
        state.rateFromSmile = true;
      }
      render();
      if (isLoggedIn() && (!customer || !vip) && attempt < 6) {
        setTimeout(function () { resolveRate(attempt + 1); }, 1500);
      }
    }).catch(function () { render(); });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function buildHtml(km) {
    var kmStr = '<span style="color:#C9A172;font-weight:700;">' + formatKM(km) + ' Knochen Mark</span>';
    var line, hint = '';
    line = 'Diese Bestellung bringt dir ' + kmStr + ', automatisch gutgeschrieben.';
    if (!isLoggedIn()) {
      hint = ' <span style="color:#B8AFA5;">Dein Konto kannst du nach dem Kauf anlegen.</span>';
    }
    return '<div style="padding:12px 0 10px;border-top:1px solid rgba(232,223,213,0.14);margin:2px 0 4px;">' +
      '<p style="margin:0 0 2px;font-family:\'Maven Pro\',Helvetica,Arial,sans-serif;font-size:10px;letter-spacing:2.5px;text-transform:uppercase;color:#C9A172;">Mark &amp; More</p>' +
      '<p style="margin:0;font-family:Helvetica,Arial,sans-serif;font-size:13px;line-height:1.55;color:#E8DFD5;">' + line + hint + '</p></div>';
  }

  var rendering = false;
  function render() {
    if (rendering) return;
    var root = document.querySelector('#slidecarthq');
    if (!root) return;
    var anchor = root.querySelector('.footer-row.amp-sc__footer-row--subtotal');
    if (!anchor) return;
    rendering = true;
    fetchCart().then(function (cart) {
      if (!cart || !cart.item_count) { remove(); rendering = false; return; }
      var km = (cart.total_price / 100) * state.ratePerEur;
      var el = document.getElementById(NUDGE_ID);
      if (!el) {
        el = document.createElement('div');
        el.id = NUDGE_ID;
        anchor.parentNode.insertBefore(el, anchor);
      }
      el.innerHTML = buildHtml(km);
      rendering = false;
    }).catch(function () { rendering = false; });
  }

  function remove() {
    var el = document.getElementById(NUDGE_ID);
    if (el) el.remove();
  }

  function observe() {
    var target = document.body;
    var pending = null;
    new MutationObserver(function () {
      var root = document.querySelector('#slidecarthq');
      if (!root) return;
      if (!document.getElementById(NUDGE_ID) || pending === null) {
        clearTimeout(pending);
        pending = setTimeout(render, 250);
      }
    }).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSmile(); observe(); });
  } else {
    initSmile(); observe();
  }
})();
